import { render } from "./WohngeldKZuschlagEdit.vue?vue&type=template&id=2aea2ef8"
import script from "./WohngeldKZuschlagEdit.vue?vue&type=script&lang=js"
export * from "./WohngeldKZuschlagEdit.vue?vue&type=script&lang=js"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__